module.exports = __webpack_public_path__ + "img/banner_11pick5_jx.a361f263.jpg";